
import '../sass/app.scss';


import { toSvg } from 'html-to-image';

const node = document.querySelector('header');

// toSvg(node)
//   .then((dataUrl) => {
//     // This is an SVG string like: "data:image/svg+xml;charset=utf-8,<svg ...</svg>"
//     const img = new Image();
//     img.src = dataUrl;
//     document.body.appendChild(img);

//     // Or download:
//     const link = document.createElement('a');
//     link.href = dataUrl;
//     link.download = 'converted.svg';
//     link.click();
//   });